<template>
    <div class="biz-bill-filter" :class="{ open: openState}">
        <div class="biz-bill-filter-wrap" v-bind:style="{'height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default">
                <div v-if="isAllGroup" class="title level1-title-font">業務分群</div>
                <rent-select class="select-scroll" v-if="isAllGroup" refName="orgGroup" style="margin-bottom: 16px;" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.groupCode">
                    <ul>
                        <li>全部</li>
                        <li v-for="(item, index) in groupList" :key="index" :data-id="item.id" :data-name="item.groupName">
                            {{item.groupName}}
                        </li>
                    </ul>
                </rent-select>
                <div class="title  level1-title-font">業務</div>
                <rent-select class="select-scroll" refName="member" selectMsg="全部" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.landlordCid || isGroupChange">
                    <ul>
                        <li>全部</li>
                        <li v-for="(item, index) in memberList" :key="index" :data-id="item.userCid" :data-name="item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default date">
                <div class="title level1-title-font">應繳日</div>
                <date-picker v-model="date" :class="{'active': date != ''}" placeholder="請選擇日期" format="YYYY.MM.DD" range></date-picker>
            </div>
            <div class="default location">
                <div class="title level1-title-font">地點</div>
                <div class="group">
                    <rent-select class="select-scroll" refName="county" selectMsg="所有縣市" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.city">
                        <ul>
                            <li :data-id="index" :data-name="county" v-for="(county, index) in countyResult" :key="index">
                                {{county}}
                            </li>
                        </ul>
                    </rent-select>
                    <rent-select class="select-scroll" refName="district" selectMsg="所有區域" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.district || isCityChange">
                        <ul v-if="filter.city">
                            <li :data-id="index" :data-name="district.districtName" v-for="(district, index) in districtsResult" :key="index">
                                {{district.districtName}}
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="default category">
                <div class="title level1-title-font">帳單分類</div>
                <rent-select  refName="category" :selectMsg="filter.bindAccountType?transSource(filter.bindAccountType):'租金雜費'" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="!filter.bindAccountType">
                    <ul>
                        <li data-id="CONTRACT_BILL">
                            租金雜費
                        </li>
                        <li data-id="BOOKING_DEPOSIT">
                            訂金
                        </li>
                        <li data-id="CONTRACT_DEPOSIT">
                            押金
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default bill">
                <div class="title level1-title-font">帳單金額</div>
                <vue-slider v-model="amount" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            openState: this.isOpen,
            filter: {
                bindAccountType: "CONTRACT_BILL",
                groupCode: null,
                landlordCid: null,
                fromDueDate: null,
                toDueDate: null,
                city: null,
                district: null,
                fromAmt: null,
                toAmt: null,
            },
            amount: [0, 100000],
            date: [],
            isCityChange: false,
            isGroupChange: false,
            isTypeChange: false,
            filterState: 0,
            myHeight: (window.innerHeight) + 'px',
            componentKey: 0
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
    },
    destroyed () {
    },
    props: {
        isOpen: Boolean,
        taskHouseInfo: Object
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        filter: {
            handler: function (val) {
                this.$store.dispatch('setBizBillMgtFilterQuery', val)
                .then(()=>{
                    this.$store.dispatch('getBizBillMgtListV2')
                    .then(()=>{
                        this.filterState = 1
                    })
                })
            },
            deep: true
        },
        amount: {
            handler: function (val) {
                if(val.length){
                    this.filter.fromAmt = val[0]
                    this.filter.toAmt = val[1]
                }
            },
            deep: true
        },
        date: {
            handler: function (val) {
                if(val.length){
                    this.filter.fromDueDate = val[0]
                    this.filter.toDueDate = val[1]
                }
            },
            deep: true
        },
        isDefault: function (val) {
            if(val){
                this.filter = {
                    bindAccountType: "CONTRACT_BILL",
                    groupCode: null,
                    landlordCid: null,
                    fromDueDate: null,
                    toDueDate: null,
                    city: null,
                    district: null,
                    fromAmt: null,
                    toAmt: null,
                }
                this.amount = [0, 100000]
                this.date = []
            }
        },
        $route:{
            handler: function (val) {
                console.log(val)

                if(val.query.filter){
                    this.filter.bindAccountType = val.query.filter
                    this.$router.replace({name: 'billMgt'})
                }
            },
            immediate: true,
            deep: true
        },
    },
    methods: {
        setFilterDefault: function () {
            this.$store.dispatch('setBizBillMgtFilterDefault')
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getSelectId: function (value) {
            this.filterState = 1
            // this.isDefault = false
            if( value.ref === 'orgGroup' ){
                this.filter.groupCode = value.id
                this.$store.dispatch('getBizMemberByGroupList',(value.id))
                this.isGroupChange = true
                this.filter.landlordCid = null
            }else if( value.ref === 'member' ){
                this.filter.landlordCid = value.id
                this.isGroupChange = false
            }else if( value.ref === 'county' ){
                this.filter.city = value.name
                this.isCityChange = true
                this.filter.district = ''
                this.$store.dispatch('getDistrict',(parseInt(value.id)+1))
            }else if( value.ref === 'district' ){
                this.isCityChange = false
                this.filter.district = value.name
            }else if( value.ref === 'category' ){
                this.filter.bindAccountType = value.id
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
    },
    computed: {
        ...mapGetters({
            groupId: 'GET_BIZ_GROUP_ID',
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            groupList: 'GET_ORG_GROUP_LIST',
            memberList: 'GET_ORG_MEMBER_BY_GROUP_LIST',
            countyResult: 'COUNTY_RESULT',
            districtsResult: 'DISTRICTS_RESULT',
            isDefault: 'GET_BIZ_BILL_MGT_FILTER_DEFAULT'
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .biz-bill-filter{
        position: fixed;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: 0px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .biz-bill-filter-wrap{
            position: relative;
            overflow-x: hidden;
            padding-bottom: 300px;
            &::-webkit-scrollbar {
                display: none;
            }
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    width: 100%;
                    .biz-rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .biz-rent-select{
                        width: 80px;
                        height: 18px;
                    }
                }
            }
            .date{
                .mx-datepicker {
                    width: 100%;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .bill{
                padding-bottom: 50px;
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .biz-bill-filter.open{
        right: 0px;
    }
    // @media screen and (max-width: 1280px) {
    //     .biz-bill-filter.open{
    //         right: 24px;
    //     }
    // }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/financialReport/billMgt/billMgtFilter.vue